export const InventoryMatchingState = {
  ALL_ITEMS: "ALL_ITEMS",
  MATCHING: "MATCHING",
  NOT_MATCHING: "NOT_MATCHING",
};
